import store from "../store/store";
import { IBookingType } from "../types";
import { updateProfile } from "./authactions";
import { firebase } from '../config/firebase.client';
import { RequestPushMsg } from "../other/NotificationFunctions";
import { onValue, runTransaction, get, off, push } from "firebase/database";
import { CANCEL_TASK, FETCH_TASKS, ACCEPT_TASK, FETCH_TASKS_FAILED, FETCH_TASKS_SUCCESS } from "../store/types";


let acceptingInProgress = new Set();

export const fetchTasks = () => (dispatch: any) => {
  const { auth, tasksRef } = firebase;

  const uid = auth?.currentUser?.uid;
  if (!uid) return;

  off(tasksRef());

  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });

  onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .map((i) => {
          data[i].id = i;
          return data[i];
        });
      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  });
};

export const getTask = (id: IBookingType['id']): Promise<IBookingType | null> | null => {
  const { auth, tasksRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return null;

  off(tasksRef());

  return new Promise((resolve, reject) => {
    onValue(tasksRef(), (snapshot) => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data)
          .filter(
            (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
          )
          .map((i) => {
            data[i].id = i;
            return data[i];
          });
        const found = arr.find(el => el.id === id)
        resolve(found);
      } else {
        resolve(null);
      }
    });
  });
};

export const acceptTask = (task: IBookingType) => async (dispatch: any) => {
  try {
    const { auth, trackingRef, singleUserRef, singleBookingRef } = firebase;
    const uid = auth?.currentUser?.uid;

    if (!uid) return;

    if (acceptingInProgress.has(task.id)) {
      return;
    }

    acceptingInProgress.add(task.id);

    const profileSnapshot = await get(singleUserRef(uid));
    const profile = profileSnapshot.val();

    if (!profile) {
      acceptingInProgress.delete(task.id);
      return;
    }

    const bookingSnapshot = await get(singleBookingRef(task.id));
    const currentBooking = bookingSnapshot.val();

    if (currentBooking && currentBooking.driver) {
      acceptingInProgress.delete(task.id);
      return;
    }

    const result = await runTransaction(singleBookingRef(task.id), (booking) => {
      if (booking && !booking.driver && booking.requestedDrivers) {
        booking.driver = uid;
        booking.driver_image = profile.profile_image || "";
        booking.car_image = profile.car_image || "";
        booking.driver_name = `${profile.firstName} ${profile.lastName}`;
        booking.driver_contact = profile.mobile || '';
        booking.driver_token = profile.pushToken || '';
        booking.vehicle_number = profile.vehicleNumber || "";
        booking.vehicle_model = profile.vehicleModel || "";
        booking.vehicle_year = profile.vehicleYear || "";
        booking.other_info = profile.other_info || "";
        booking.driverRating = profile.rating || "0";
        booking.fleetadmin = profile.fleetadmin || "";
        booking.status = "ACCEPTED";
        booking.driverDeviceId = task.driverDeviceId || null;
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        return booking;
      }
      return;
    });

    if (!result || !result.snapshot.exists()) {
      acceptingInProgress.delete(task.id);
      return;
    }

    const finalBooking = result.snapshot.val();
    if (finalBooking.driver !== uid) {
      acceptingInProgress.delete(task.id);
      return;
    }


    updateProfile({ queue: true })(dispatch);

    RequestPushMsg(task.customer_token, {
      screen: "BookedCab",
      params: { bookingId: task.id },
      title: store.getState().languagedata.defaultLanguage.notification_title,
      msg: `${store.getState().languagedata.defaultLanguage.driver} ${profile.firstName}, ${store.getState().languagedata.defaultLanguage.accept_booking_request}`,
    });

    const driverLocation = store.getState().gpsdata.location;
    await push(trackingRef(task.id), {
      at: new Date().getTime(),
      status: "ACCEPTED",
      lat: driverLocation.lat,
      lng: driverLocation.lng,
    });

    dispatch({
      type: ACCEPT_TASK,
      payload: { task: task },
    });

    acceptingInProgress.delete(task.id);

  } catch (e) {
    console.error(e);
    acceptingInProgress.delete(task.id);
  }
};

export const cancelTask = (bookingId: any) => (dispatch: any) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  runTransaction(singleBookingRef(bookingId), (booking) => {
    if (booking && booking.requestedDrivers) {
      if (
        booking.requestedDrivers !== null &&
        Object.keys(booking.requestedDrivers).length === 1
      ) {
        booking.status = "NEW";
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        RequestPushMsg(booking.customer_token, {
          screen: "BookedCab",
          params: { bookingId: bookingId },
          msg: store.getState().languagedata.defaultLanguage.booking_cancelled,
          title: store.getState().languagedata.defaultLanguage.notification_title,
        });
        dispatch({
          type: CANCEL_TASK,
          payload: { uid: uid, bookingId: bookingId },
        });
      } else {
        delete booking.requestedDrivers[uid];
      }
      if (booking.driverOffers && booking.driverOffers[uid]) {
        delete booking.driverOffers[uid];
      }
      if (booking.selectedBid && booking.selectedBid.driver === uid) {
        delete booking.selectedBid;
      }
      return booking;
    }
  });
};